import * as React from 'react';

import UtmParametersHelpGraphicSvg from './utm-parameters-help-graphic.svg';

import styles from './utm-parameters-help-graphic.module.css';

export class UtmParametersHelpGraphic extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles.container}>
                <UtmParametersHelpGraphicSvg />
            </div>
        );
    }
}
